import uiCore = require("../core/uicore");

export class Reports implements uiCore.IDirective {
    
    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "reports",
        Url: "/reports",
        HeaderText: "Reports",
        StateString: "reports",
        Template: "",
        IsAbstract: true,
        AngularDependencies: []
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/reports/reports.ts